export class ConsumerComplaintTypeModel {
    constructor(data = {}) {
        this.id = data.id ?? null;
        this.complaintId = data.complaintId ?? null;
        this.complaintType = data.complaintType ?? '';
        this.manualComplaintExplanation = data.manualComplaintExplanation ?? '';
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }
}
